<template>
  <div class="skeleton-game-card">
    <!-- Background Image Placeholder -->
    <div class="skeleton-background">
      <div class="skeleton-shimmer"></div>
    </div>

    <!-- Online Count - Top Right -->
    <div class="skeleton-online-count">
      <div class="skeleton-shimmer"></div>
    </div>

    <!-- Content Overlay -->
    <div class="skeleton-content">
      <!-- Row 1: Provider and Percentage -->
      <div class="skeleton-row-1">
        <div class="skeleton-provider">
          <div class="skeleton-shimmer"></div>
        </div>
        <div class="skeleton-percentage">
          <div class="skeleton-shimmer"></div>
        </div>
      </div>

      <!-- Row 2: Game Name -->
      <div class="skeleton-row-2">
        <div class="skeleton-game-name">
          <div class="skeleton-shimmer"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonGameCard'
}
</script>

<style lang="scss" scoped>
.skeleton-game-card {
  position: relative;
  width: 100%;
  aspect-ratio: 3/4.1;
  background: linear-gradient(
    135deg,
    rgba(26, 26, 46, 0.8),
    rgba(22, 33, 62, 0.8)
  );
  border-radius: 10px;
  overflow: hidden;
  cursor: default;

  // Match GameCard responsive widths
  min-width: 180px;
  max-width: 180px;

  @media (max-width: 768px) {
    min-width: 160px;
    max-width: 160px;
  }

  @media (max-width: 480px) {
    min-width: 140px;
    max-width: 140px;
  }
}

.skeleton-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    135deg,
    rgba(45, 45, 65, 0.4),
    rgba(35, 45, 75, 0.4)
  );
  border-radius: 10px;
}

.skeleton-online-count {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 40px;
  height: 16px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  backdrop-filter: blur(4px);

  @media (max-width: 768px) {
    width: 35px;
    height: 14px;
    top: 6px;
    right: 6px;
  }
}

.skeleton-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px 10px;
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.85) 0%,
    rgba(0, 0, 0, 0.6) 60%,
    transparent 100%
  );
  border-radius: 0 0 10px 10px;

  @media (max-width: 768px) {
    padding: 10px 8px;
  }

  @media (max-width: 480px) {
    padding: 8px 6px;
  }
}

.skeleton-row-1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;

  @media (max-width: 768px) {
    margin-bottom: 6px;
  }
}

.skeleton-provider {
  width: 60px;
  height: 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 6px;

  @media (max-width: 768px) {
    width: 50px;
    height: 10px;
  }
}

.skeleton-percentage {
  width: 45px;
  height: 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 6px;

  @media (max-width: 768px) {
    width: 40px;
    height: 10px;
  }
}

.skeleton-row-2 {
  width: 100%;
}

.skeleton-game-name {
  width: 85%;
  height: 16px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 8px;

  @media (max-width: 768px) {
    height: 14px;
  }

  @media (max-width: 480px) {
    height: 12px;
  }
}

// Shimmer animation
.skeleton-shimmer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.08),
    transparent
  );
  animation: shimmer 2s infinite;
  border-radius: inherit;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

// Performance optimizations
.skeleton-game-card {
  will-change: contents;
  transform: translate3d(0, 0, 0);
}
</style>
